/**
 * Bella Vita – großes ẞ bei CSS-Großschreibung verwenden
 *
 * Beispiele:
 *   Größen und Maße  → GRÖẞEN UND MAẞE
 *   Straße           → STRAẞE
 *   Wasser           → WASSER
 *
 * Wichtig:
 * Es wird ausschließlich ein tatsächlich vorhandenes ß zu ẞ geändert.
 * "SS" wird niemals verändert.
 */

(() => {
  'use strict';

  const EXCLUDED_TAGS = new Set([
    'SCRIPT',
    'STYLE',
    'NOSCRIPT',
    'TEXTAREA',
    'INPUT',
    'OPTION',
    'SELECT'
  ]);

  /**
   * Prüft, ob ein Textknoten verarbeitet werden soll.
   */
  function shouldProcessTextNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return false;

    // Kein kleines ß vorhanden → nichts zu tun.
    if (!node.nodeValue || !node.nodeValue.includes('ß')) return false;

    const parent = node.parentElement;
    if (!parent) return false;

    // Bestimmte Elemente nicht verändern.
    if (EXCLUDED_TAGS.has(parent.tagName)) return false;

    // Editierbare Bereiche nicht verändern.
    if (parent.closest('[contenteditable="true"]')) return false;

    // Nur eingreifen, wenn der Text tatsächlich per CSS
    // in Großbuchstaben dargestellt wird.
    return getComputedStyle(parent).textTransform === 'uppercase';
  }

  /**
   * Wandelt ein tatsächlich vorhandenes kleines ß
   * in das große ẞ um.
   */
  function processTextNode(node) {
    if (!shouldProcessTextNode(node)) return;

    node.nodeValue = node.nodeValue.replace(/ß/g, 'ẞ');
  }

  /**
   * Durchsucht einen Bereich nach passenden Textknoten.
   */
  function processElement(root) {
    if (!root) return;

    // Falls direkt ein Textknoten übergeben wurde.
    if (root.nodeType === Node.TEXT_NODE) {
      processTextNode(root);
      return;
    }

    if (
      root.nodeType !== Node.ELEMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_NODE &&
      root.nodeType !== Node.DOCUMENT_FRAGMENT_NODE
    ) {
      return;
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT
    );

    const nodes = [];

    while (walker.nextNode()) {
      if (shouldProcessTextNode(walker.currentNode)) {
        nodes.push(walker.currentNode);
      }
    }

    // Erst sammeln, dann verändern.
    nodes.forEach(processTextNode);
  }

  /**
   * Beobachtet dynamisch nachgeladene Inhalte.
   *
   * Relevant z. B. für:
   * - Shopify Sections
   * - Ajax-Inhalte
   * - Modals
   * - Apps
   * - nachgeladene Produktinformationen
   */
  function observeChanges() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {

        // Neu eingefügte Inhalte prüfen.
        mutation.addedNodes.forEach((node) => {
          if (
            node.nodeType === Node.ELEMENT_NODE ||
            node.nodeType === Node.TEXT_NODE
          ) {
            processElement(node);
          }
        });

        // Dynamisch geänderte Textknoten prüfen.
        if (
          mutation.type === 'characterData' &&
          mutation.target.nodeType === Node.TEXT_NODE
        ) {
          processTextNode(mutation.target);
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  /**
   * Start
   */
  function init() {
    processElement(document.body);
    observeChanges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, {
      once: true
    });
  } else {
    init();
  }
})();